<template>
  <div>
    <NavBar v-bind:displayLogo="true" v-bind:displayUser="false"></NavBar>
    <div class="container-login justify-content-center">
      <div class="card-login">
        <div class="card-header-login">

          <h5>Registro</h5>
          <button class="btn btn-primary" @click="homeRedirect">Inicio</button>
        </div>
        <div class="card-body">
          <div id="register"></div>
        </div>
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import NavBar from '@component-basic/NavBar.vue'
import { config } from '@/formio/config'
import { navBar,lan_es } from '@utils/translations';

export default {
  components: {
    NavBar,
  },
  data() {
    var lenguaje = localStorage.getItem("lang");
    localStorage.setItem('lang', 'es')
    return {
      artboRegisterUrl: config.forms.register,
      fail: "",
      load:"",
      sessionStart: "",
      alert: true,
      alertMsg: ""
    };
  },
  created: function(){
    localStorage.removeItem("formioUser");
    localStorage.removeItem('formioToken');
  },
  mounted() {
    localStorage.removeItem("formioUser");
    localStorage.removeItem('formioToken');
    localStorage.setItem('lang', 'es')
    
    let lang = localStorage.getItem('lang');
    
    this.home =  navBar[lang].home;
    this.register =  navBar[lang].register;

    let submitFunction = this.onSubmitMethod;
    let modal = this.setModal;

    Formio.createForm(document.getElementById("register"),this.artboRegisterUrl )
            .then(function(form){
                      form.options.highlightErrors = false;
                      form.options.disableAlerts = true;
                      form.options.noAlerts = true;
                      form.icons = 'fontawesome';
                      form.addLanguage('es',lan_es);
                      form.language = lang;
                      form.on('render',function(e){
                      }),
                              form.on('error',function(e){
                                modal(loginTxt[lang].error)
                              }),
                              form.on('submit',function(e){
                                submitFunction(e);
                              })
                    }
            );
  },
  methods: {
    onSubmitMethod: function(submission) {
      var val = submission.data.submit;
      if(submission.data.submit){
        this.validation = true;
        if(this.validation)
        {
          localStorage.setItem('formioUser', JSON.stringify(submission));
          setTimeout(() => {
            this.$router.push('/auth/login')
          }, 2000)
        }
      }
    },
    homeRedirect: function() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
